if (!customElements.get('blog-filter')) {
  customElements.define(
    'blog-filter',
    class BlogFilter extends HTMLElement {
      connectedCallback() {
        this.pageCache = new Map();
        this.abortController = null;
        this.addEventListener('click', this.onClick.bind(this));
        window.addEventListener('popstate', this.onPopState.bind(this));
      }

      onClick(event) {
        const link = event.target.closest('.main-blog__filter, .pagination__item');

        if (
          !link ||
          !link.href ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) return;

        event.preventDefault();
        this.load(link.href, true);
      }

      onPopState() {
        this.load(window.location.href, false);
      }

      async load(url, updateHistory) {
        const requestUrl = new URL(url, window.location.origin).href;
        const scrollPosition = window.scrollY;

        this.abortController?.abort();
        this.abortController = new AbortController();
        this.setAttribute('aria-busy', 'true');

        try {
          let responseText = this.pageCache.get(requestUrl);

          if (!responseText) {
            const response = await fetch(requestUrl, { signal: this.abortController.signal });
            if (!response.ok) throw new Error(`Blog filter request failed: ${response.status}`);
            responseText = await response.text();
            this.pageCache.set(requestUrl, responseText);
          }

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selector = `blog-filter[data-section-id="${this.dataset.sectionId}"]`;
          const replacement = html.querySelector(selector);

          if (!replacement) throw new Error('Blog filter markup was not found');

          this.innerHTML = replacement.innerHTML;
          if (updateHistory) window.history.pushState({}, '', requestUrl);
          requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
        } catch (error) {
          if (error.name !== 'AbortError') window.location.assign(requestUrl);
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
